import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { IncidenciaHost, IncidenciaHostComentario, IncidenciaHostDetalle, IncidenciaHostReq, IncidenciaHostRes, IncidenciaHostTipoServicio, EstadoIncidenciaHost } from "../shared/model/iso42001/incidencia-host.model";
import { UrlConstantes } from "../utilerias/constantes/urlconstantes";
import { archivoSinSelloDeError, sinSelloDeError } from "../shared/http/sello-de-error";

/**
 * Las validaciones de negocio (fechas, flujo, responsables) salen del servidor como HTTP 200 con cuerpo
 * vacío y el motivo en la cabecera MESSAGE; sinSelloDeError las convierte en error para que la pantalla
 * las muestre en lugar de tratarlas como guardado exitoso.
 */
@Injectable({
  providedIn: "root",
})
export class IncidenciasHostService {
  constructor(private http: HttpClient) {}

  consultarKanban(filtro: IncidenciaHost, regInicial: number, regXPagina: number): Observable<IncidenciaHostRes> {
    const req: IncidenciaHostReq = { filtro, regInicial, regXPagina };
    return this.http.post<IncidenciaHostRes>(UrlConstantes.ISO42001_INCIDENCIA_HOST_CONSULTAR_KANBAN, req, { observe: "response" }).pipe(sinSelloDeError());
  }

  obtener(idIncidenciaHost: number): Observable<IncidenciaHostRes> {
    const req: IncidenciaHostReq = { idIncidenciaHost };
    return this.http.post<IncidenciaHostRes>(UrlConstantes.ISO42001_INCIDENCIA_HOST_OBTENER, req, { observe: "response" }).pipe(sinSelloDeError());
  }

  catalogos(): Observable<IncidenciaHostRes> {
    return this.http.post<IncidenciaHostRes>(UrlConstantes.ISO42001_INCIDENCIA_HOST_CATALOGOS, {}, { observe: "response" }).pipe(sinSelloDeError());
  }

  guardar(incidencia: IncidenciaHost): Observable<IncidenciaHostRes> {
    const req: IncidenciaHostReq = { incidencia };
    return this.http.post<IncidenciaHostRes>(UrlConstantes.ISO42001_INCIDENCIA_HOST_GUARDAR, req, { observe: "response" }).pipe(sinSelloDeError());
  }

  actualizar(incidencia: IncidenciaHost): Observable<IncidenciaHostRes> {
    const req: IncidenciaHostReq = { incidencia };
    return this.http.post<IncidenciaHostRes>(UrlConstantes.ISO42001_INCIDENCIA_HOST_ACTUALIZAR, req, { observe: "response" }).pipe(sinSelloDeError());
  }

  cambiarEstado(
    idIncidenciaHost: number,
    estadoEvento: EstadoIncidenciaHost,
    incidencia?: IncidenciaHost,
    comentarioTransicion?: string,
  ): Observable<IncidenciaHostRes> {
    const req: IncidenciaHostReq = { idIncidenciaHost, estadoEvento, incidencia, comentarioTransicion };
    return this.http.post<IncidenciaHostRes>(UrlConstantes.ISO42001_INCIDENCIA_HOST_CAMBIAR_ESTADO, req, { observe: "response" }).pipe(sinSelloDeError());
  }

  guardarTipoServicio(tipoServicio: IncidenciaHostTipoServicio): Observable<IncidenciaHostRes> {
    const req: IncidenciaHostReq = { tipoServicio };
    return this.http.post<IncidenciaHostRes>(UrlConstantes.ISO42001_INCIDENCIA_HOST_TIPO_SERVICIO_GUARDAR, req, { observe: "response" }).pipe(sinSelloDeError());
  }

  guardarDetalle(detalle: IncidenciaHostDetalle): Observable<IncidenciaHostRes> {
    const req: IncidenciaHostReq = { detalle };
    return this.http.post<IncidenciaHostRes>(UrlConstantes.ISO42001_INCIDENCIA_HOST_DETALLE_GUARDAR, req, { observe: "response" }).pipe(sinSelloDeError());
  }

  guardarComentario(comentario: IncidenciaHostComentario): Observable<IncidenciaHostRes> {
    const req: IncidenciaHostReq = { comentario };
    return this.http.post<IncidenciaHostRes>(UrlConstantes.ISO42001_INCIDENCIA_HOST_COMENTARIO_GUARDAR, req, { observe: "response" }).pipe(sinSelloDeError());
  }

  actualizarComentario(comentario: IncidenciaHostComentario): Observable<IncidenciaHostRes> {
    const req: IncidenciaHostReq = { comentario };
    return this.http.post<IncidenciaHostRes>(UrlConstantes.ISO42001_INCIDENCIA_HOST_COMENTARIO_ACTUALIZAR, req, { observe: "response" }).pipe(sinSelloDeError());
  }

  uploadArchivo(formData: FormData): Observable<IncidenciaHostRes> {
    return this.http.post<IncidenciaHostRes>(UrlConstantes.ISO42001_INCIDENCIA_HOST_ARCHIVO_UPLOAD, formData, { observe: "response" }).pipe(sinSelloDeError());
  }

  descargarArchivo(idArchivoHost: number): Observable<Blob> {
    return this.http.get(UrlConstantes.ISO42001_INCIDENCIA_HOST_ARCHIVO_DESCARGAR + "?idArchivoHost=" + idArchivoHost, {
      observe: "response",
      responseType: "blob",
    }).pipe(
      archivoSinSelloDeError(),
      map((resultado) => {
        if (resultado.tipo === "vacio") {
          throw new Error("El archivo no está disponible para descarga.");
        }
        return resultado.blob;
      }),
    );
  }
}
